import React from 'react';
import { useTranslations } from 'next-intl';
import type { PhoneAnswerRateProps } from '../model/types';
export const PhoneAnswerRate: React.FC<PhoneAnswerRateProps> = ({
  percentage
}) => {
  const t = useTranslations();
  return <span className="text-center text-xs text-textSecondary" data-sentry-component="PhoneAnswerRate" data-sentry-source-file="PhoneAnswerRate.tsx">
      {percentage ? t('bookingPage.reached_users', {
      percentage
    }) : t('bookingPage.no_reached_users')}
    </span>
  // <span className="text-center text-xs text-textSecondary">{t('bookingPage.reached_users', { percentage })}</span>
  ;
};